'use client';

import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { LandingPage } from '../components/LandingPage';
import { Quiz } from '../components/Quiz';
import { getLandingPageData } from '@/lib/landing/mapping';

export function Home() {
  const [mostrarQuiz, setMostrarQuiz] = useState(false);
  const landingData = getLandingPageData();

  useEffect(() => {
    if (!mostrarQuiz) {
      return;
    }

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setMostrarQuiz(false);
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mostrarQuiz]);

  return (
    <>
      <LandingPage onIniciarQuiz={() => setMostrarQuiz(true)} />

      <AnimatePresence>
        {mostrarQuiz && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[300] p-3 md:p-6"
            style={{ willChange: 'opacity' }}
          >
            <button
              type="button"
              aria-label="Fechar quiz"
              onClick={() => setMostrarQuiz(false)}
              className="absolute inset-0 bg-black/72 glass-soft"
            />

            <div className="relative flex h-full items-center justify-center">
              <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.97 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 12, scale: 0.98 }}
                transition={{ duration: 0.24, ease: 'easeOut' }}
                className="relative h-full max-h-[calc(100vh-1.5rem)] w-full max-w-6xl overflow-hidden rounded-[32px] border border-white/15 bg-black/80 shadow-[0_40px_120px_rgba(0,0,0,0.6)] md:max-h-[calc(100vh-3rem)] gpu-layer"
                style={{ willChange: 'transform, opacity' }}
              >
                <div className="absolute inset-0 bg-white/[0.05] glass-strong" />
                <div className="absolute inset-0 bg-gradient-to-br from-white/[0.08] via-transparent to-pink-500/[0.08]" />
                <Quiz onVoltar={() => setMostrarQuiz(false)} inModal landingData={landingData} />
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
